import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "mobile-footer-component" };
const _hoisted_2 = { class: "footer-nav" };
const _hoisted_3 = ["src", "alt"];
const _hoisted_4 = ["href", "onClick"];
const _hoisted_5 = ["src", "alt"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_router_link = _resolveComponent("router-link");
    return (_openBlock(), _createElementBlock("header", _hoisted_1, [
        _createElementVNode("nav", null, [
            _createElementVNode("ul", _hoisted_2, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navLinks, (link) => {
                    return (_openBlock(), _createElementBlock("li", {
                        key: link.label,
                        class: _normalizeClass(["footer-nav-item", {
                                'center-item': link.label === 'Menu',
                                'left-curve': link.label === 'Casino',
                                'right-curve': link.label === 'Live Casino',
                            }])
                    }, [
                        (link.label !== 'Live Casino')
                            ? (_openBlock(), _createBlock(_component_router_link, {
                                key: 0,
                                to: link.to || '#',
                                class: "footer-nav-link",
                                onClick: ($event) => (link.onClick && link.onClick())
                            }, {
                                default: _withCtx(() => [
                                    _createElementVNode("div", {
                                        class: _normalizeClass(["icon-container", {
                                                'active-icon': _ctx.isActive(link.route),
                                            }])
                                    }, [
                                        _createElementVNode("img", {
                                            src: link.img,
                                            alt: link.label,
                                            class: "nav-icon"
                                        }, null, 8, _hoisted_3)
                                    ], 2),
                                    _createElementVNode("span", {
                                        class: _normalizeClass(["nav-label", {
                                                'active-label': _ctx.isActive(link.route),
                                            }])
                                    }, _toDisplayString(link.label), 3)
                                ]),
                                _: 2
                            }, 1032, ["to", "onClick"]))
                            : (_openBlock(), _createElementBlock("a", {
                                key: 1,
                                href: link.to || '#',
                                class: "footer-nav-link",
                                onClick: _withModifiers(($event) => (link.onClick && link.onClick()), ["prevent"])
                            }, [
                                _createElementVNode("div", {
                                    class: _normalizeClass(["icon-container", {
                                            'active-icon': _ctx.isActive(link.route),
                                        }])
                                }, [
                                    _createElementVNode("img", {
                                        src: link.img,
                                        alt: link.label,
                                        class: "nav-icon"
                                    }, null, 8, _hoisted_5)
                                ], 2),
                                _createElementVNode("span", {
                                    class: _normalizeClass(["nav-label", {
                                            'active-label': _ctx.isActive(link.route),
                                        }])
                                }, _toDisplayString(link.label), 3)
                            ], 8, _hoisted_4))
                    ], 2));
                }), 128))
            ])
        ])
    ]));
}
